import ActionsForm from '@/shared/mixins/actionsForm'
import ModalSimulacao from './modal/simulacaomodal.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import AjuizamentoSimulacaoRepository from '@/shared/http/repositories/crm/ajuizamentoSimulacao.js'
import { loading } from '@/shared/utils/UIHelper.js'

// import AjuizamentoRepository from '@/shared/http/repositories/crm/ajuizamento.js'
// import BoardRepositoryV2 from '../../../../../shared/http/repositories/crm/board_v2.js'
// import TextTruncate from './TextTruncate.vue'
// import { toast } from '../../../../../shared/utils/UIHelper.js'
// import MoveCardPopover from '../../components/moveCardColumn/moveCardColumn.vue'
// import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
// import JWTService from '../../../../../shared/services/jwt.js'
// import Roles from '@/shared/utils/roles.js'

export default {
  name: 'CrmSimulacao',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return { }
  },
  components: {
    DefaultButton,
    ModalSimulacao
  },
  computed: {
    cardActive () {
      return this.card && this.card.situacao === 'ATIVO' && !this.card.boardColumn.board.arquivado && !this.card.boardColumn.board.isReadOnly && !this.card.readOnly
    }
  },
  methods: {
    async onLoad () {
      await this.onSearch()
    },
    async onSearch () {
      loading.push()

      try {
        const response = await AjuizamentoSimulacaoRepository.GetByCardVinculado(this.card.id)
        const responseFinal = {
          ...response,
          data: {
            content: response.data.map(x => ({
              ...x,
              status: 0,
              ativo: true
            }))
          }
        }
        this.onResultGrid(responseFinal)
      } catch (error) {
        console.error(error)
      } finally {
        loading.pop()
      }
    },
    onReload () {
      this.onLoad()
    },
    formatDate (date) {
      if (!date) {
        return ''
      }

      const dateObj = new Date(date)
      dateObj.setDate(dateObj.getDate() + 1)

      return dateObj.toLocaleString('pt-BR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    addSimulacao () {
      this.$refs.ModalSimulacao.showModal()
    },
    async onDelete (obj) {
      loading.push()

      try {
        await AjuizamentoSimulacaoRepository.Delete(obj.id)
        this.onSearch()
      } catch (error) {
        console.error(error)
      } finally {
        loading.pop()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/simulacao/simulacao.js